var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custome-card"},[_c('GmapMap',{staticStyle:{"width":"100%","height":"200px"},attrs:{"options":{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUi: false
        },"center":_vm.center,"map-type-id":"roadmap","zoom":_vm.zoom}}),_c('div',{staticClass:"p-3"},[_c('div',{staticClass:"shift-top text-center"},[_c('img',{staticClass:"business-logo",attrs:{"src":_vm.image,"alt":"business logo"}})]),_c('div',{staticClass:"text-center b-details"},[_c('p',{staticClass:"font14"},[_vm._v(_vm._s(_vm.name))]),_c('button',{staticClass:"font12 btn btn-warning",on:{"click":_vm.handleClick}},[_vm._v("Show Services")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }